/**
 * PRIMA GOLD - Optimized Jewelry Category Filter & Collection Aggregator
 * Performance-focused: SessionStorage Caching, Image CDN optimization (&width=533),
 * Zero-flicker Page 1 rendering, and smooth transitions.
 */
(function() {
  'use strict';

  var PRODUCTS_PER_PAGE = 16;
  var CACHE_TTL_MS = 1000 * 60 * 30; // 30 minutes
  var currentActivePage = 1;
  var currentDisplayedList = null;

  // Global in-memory cache
  window.__primaCollectionProducts = window.__primaCollectionProducts || null;
  window.__primaOriginalGridHTML = window.__primaOriginalGridHTML || null;

  function getCategoryByTitle(title) {
    if (!title) return '';
    var t = ' ' + title.toLowerCase() + ' ';

    // 1. Earrings (Check first to avoid collision with "earRING")
    if (t.indexOf('earring') !== -1 || t.indexOf('bông tai') !== -1 || t.indexOf('khuyên tai') !== -1 || t.indexOf('hoa tai') !== -1) {
      return 'earrings';
    }
    // 2. Ring (Strictly when not earrings)
    if (t.indexOf('ring') !== -1 || t.indexOf('nhẫn') !== -1) {
      return 'ring';
    }
    // 3. Bracelet
    if (t.indexOf('bracelet') !== -1 || t.indexOf('bangle') !== -1 || t.indexOf('lắc') !== -1 || t.indexOf('vòng tay') !== -1) {
      return 'bracelet';
    }
    // 4. Charm
    if (t.indexOf('charm') !== -1) {
      return 'charm';
    }
    // 5. Pendant
    if (t.indexOf('pendant') !== -1 || t.indexOf('mặt dây') !== -1) {
      return 'pendant';
    }
    // 6. Necklace
    if (t.indexOf('necklace') !== -1 || t.indexOf('vòng cổ') !== -1 || t.indexOf('dây chuyền') !== -1 || t.indexOf('kiềng') !== -1 || t.indexOf('chain') !== -1) {
      return 'necklace';
    }
    return '';
  }

  function getOptimizedImg(src, width) {
    if (!src) return '';
    var w = width || 533;
    if (src.indexOf('cdn.shopify.com') !== -1) {
      return src + (src.indexOf('?') === -1 ? '?width=' + w : '&width=' + w);
    }
    return src;
  }

  function formatVND(amount) {
    if (isNaN(amount)) return amount || '';
    return new Intl.NumberFormat('vi-VN').format(Math.round(amount)) + ' VND';
  }

  function minifyProduct(p) {
    var img1 = (p.images && p.images[0]) ? p.images[0].src : (p.img1 || '');
    var img2 = (p.images && p.images[1]) ? p.images[1].src : (p.img2 || img1);
    var price = p.price !== undefined ? p.price : (p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0);
    var comparePrice = p.compare_price !== undefined ? p.compare_price : (p.variants && p.variants[0] && p.variants[0].compare_at_price ? parseFloat(p.variants[0].compare_at_price) : 0);
    var variantId = p.variant_id || (p.variants && p.variants[0] ? p.variants[0].id : '');
    return {
      id: p.id,
      variant_id: variantId,
      title: p.title || '',
      handle: p.handle || '',
      img1: img1,
      img2: img2,
      price: price,
      compare_price: comparePrice,
      type: p.product_type || p.type || '',
      tags: p.tags || []
    };
  }

  function getCache(key) {
    try {
      var item = sessionStorage.getItem(key);
      if (!item) return null;
      var parsed = JSON.parse(item);
      if (parsed && Array.isArray(parsed.products) && (Date.now() - parsed.timestamp < CACHE_TTL_MS)) {
        return parsed.products;
      }
    } catch(e) {}
    return null;
  }

  function setCache(key, products) {
    try {
      sessionStorage.setItem(key, JSON.stringify({
        timestamp: Date.now(),
        products: products
      }));
    } catch(e) {}
  }

  function fetchAllCollectionProducts(callback) {
    if (window.__primaCollectionProducts) {
      if (callback) callback(window.__primaCollectionProducts);
      return;
    }

    var basePath = window.location.pathname.replace(/\/$/, '');
    var isGoldCollection = basePath.endsWith('/collections/gold') || 
                           (basePath.indexOf('/collections/gold') !== -1 && basePath.indexOf('/collections/gold-') === -1);

    var cacheKey = isGoldCollection ? '__prima_gold_combined_v4' : ('__prima_coll_v4_' + basePath);
    var cached = getCache(cacheKey);
    if (cached) {
      window.__primaCollectionProducts = cached;
      if (callback) callback(cached);
      return;
    }

    if (isGoldCollection) {
      var goldHandles = [
        'gold',
        'gold-24k',
        'gold-pendants',
        'gold-necklaces',
        'gold-ring',
        'gold-bangles',
        'gold-earrings'
      ];

      var fetchPromises = goldHandles.map(function(handle) {
        return fetch('/collections/' + handle + '/products.json?limit=250')
          .then(function(res) { return res.json(); })
          .then(function(data) { return data.products || []; })
          .catch(function() { return []; });
      });

      Promise.all(fetchPromises)
        .then(function(results) {
          var existingIds = {};
          var combined = [];

          results.forEach(function(productList) {
            productList.forEach(function(p) {
              if (!existingIds[p.id]) {
                existingIds[p.id] = true;
                combined.push(minifyProduct(p));
              }
            });
          });

          window.__primaCollectionProducts = combined;
          setCache(cacheKey, combined);
          if (callback) callback(combined);
        })
        .catch(function(err) {
          console.warn('Could not fetch combined gold collections:', err);
        });
      return;
    }

    var url1 = basePath + '/products.json?limit=250';
    var url2 = basePath + '/products.json?limit=250&page=2';

    fetch(url1)
      .then(function(res) { return res.json(); })
      .then(function(data1) {
        var raw = data1.products || [];
        if (raw.length >= 250) {
          fetch(url2)
            .then(function(res2) { return res2.json(); })
            .then(function(data2) {
              raw = raw.concat(data2.products || []);
              var minified = raw.map(minifyProduct);
              window.__primaCollectionProducts = minified;
              setCache(cacheKey, minified);
              if (callback) callback(minified);
            })
            .catch(function() {
              var minified = raw.map(minifyProduct);
              window.__primaCollectionProducts = minified;
              setCache(cacheKey, minified);
              if (callback) callback(minified);
            });
        } else {
          var minified = raw.map(minifyProduct);
          window.__primaCollectionProducts = minified;
          setCache(cacheKey, minified);
          if (callback) callback(minified);
        }
      })
      .catch(function(err) {
        console.warn('Could not fetch products.json:', err);
      });
  }

  function updateCategoryCounts(products) {
    if (!products || !products.length) return;

    var counts = { pendant: 0, ring: 0, earrings: 0, bracelet: 0, necklace: 0, charm: 0 };

    for (var i = 0; i < products.length; i++) {
      var cat = getCategoryByTitle(products[i].title);
      if (cat && counts[cat] !== undefined) {
        counts[cat]++;
      }
    }

    var pCount = document.querySelector('.js-count-pendant');
    var rCount = document.querySelector('.js-count-ring');
    var eCount = document.querySelector('.js-count-earrings');
    var bCount = document.querySelector('.js-count-bracelet');
    var nCount = document.querySelector('.js-count-necklace');
    var cCount = document.querySelector('.js-count-charm');

    if (pCount) pCount.textContent = '(' + counts.pendant + ')';
    if (rCount) rCount.textContent = '(' + counts.ring + ')';
    if (eCount) eCount.textContent = '(' + counts.earrings + ')';
    if (bCount) bCount.textContent = '(' + counts.bracelet + ')';
    if (nCount) nCount.textContent = '(' + counts.necklace + ')';
    if (cCount) cCount.textContent = '(' + counts.charm + ')';
  }

  function buildProductCardHTML(p, brandLogoUrl) {
    var firstImg = p.img1 || ((p.images && p.images[0]) ? p.images[0].src : '');
    var secondImg = p.img2 || ((p.images && p.images[1]) ? p.images[1].src : firstImg);
    var firstImgOpt = getOptimizedImg(firstImg, 533);
    var secondImgOpt = getOptimizedImg(secondImg, 533);
    var price = p.price !== undefined ? p.price : (p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0);
    var comparePrice = p.compare_price !== undefined ? p.compare_price : (p.variants && p.variants[0] && p.variants[0].compare_at_price ? parseFloat(p.variants[0].compare_at_price) : 0);
    var priceFormatted = formatVND(price);
    var comparePriceFormatted = formatVND(comparePrice);
    var hasDiscount = comparePrice > price;
    var discPct = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
    var productUrl = '/products/' + p.handle;
    var safeTitle = (p.title || '').replace(/"/g, '&quot;');

    var html = '';
    html += '<li class="grid__item" data-product-title="' + safeTitle + '">';
    html += '  <div class="product-card-wrapper">';
    html += '    <div class="card card--standard card--media">';
    html += '      <div class="card__inner color-scheme-1 ratio" style="--ratio-percent: 100%;">';
    html += '        <div class="card__media">';
    html += '          <div class="media media--transparent media--hover-effect">';
    html += '            <a href="' + productUrl + '" class="prima-product-card__img-link" style="display:block;width:100%;height:100%;">';
    html += '              <img src="' + firstImgOpt + '" alt="' + safeTitle + '" class="motion-reduce prima-product-card__img" loading="lazy" width="533" height="533" style="width:100%;height:100%;object-fit:cover;">';
    if (secondImgOpt && secondImgOpt !== firstImgOpt) {
      html += '              <img src="' + secondImgOpt + '" alt="' + safeTitle + '" class="motion-reduce prima-product-card__img prima-product-card__img--secondary" loading="lazy" width="533" height="533" style="width:100%;height:100%;object-fit:cover;">';
    }
    html += '            </a>';
    html += '          </div>';
    html += '        </div>';

    var tagsStr = (p.tags && Array.isArray(p.tags)) ? p.tags.join(' ') : '';
    var isJolly = (window.location.pathname.toLowerCase().indexOf('jolly') !== -1) ||
                  ((p.title || '').toLowerCase().indexOf('jolly') !== -1) ||
                  ((p.type || '').toLowerCase().indexOf('jolly') !== -1) ||
                  (tagsStr.toLowerCase().indexOf('jolly') !== -1);

    if (!isJolly && brandLogoUrl) {
      html += '        <div class="prima-product-card__brand-bar">';
      html += '          <img src="' + brandLogoUrl + '" alt="PRIMA" class="prima-product-card__brand-logo" loading="lazy" width="70" height="auto">';
      html += '        </div>';
    }

    var variantId = p.variant_id || (p.variants && p.variants[0] ? p.variants[0].id : '');
    html += '        <button type="button" class="prima-product-card__quickview-btn js-prima-quickview" data-variant-id="' + variantId + '" data-title="' + safeTitle + '" data-price="' + priceFormatted + '" data-compare-price="' + (hasDiscount ? comparePriceFormatted : '') + '" data-has-discount="' + hasDiscount + '" data-discount-badge="' + (hasDiscount ? '-' + discPct + '%' : '') + '" data-url="' + productUrl + '" data-image="' + firstImgOpt + '" aria-label="Xem nhanh ' + safeTitle + '">';
    html += '          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
    html += '          <span class="prima-product-card__quickview-text">XEM NHANH</span>';
    html += '        </button>';
    if (hasDiscount) {
      html += '        <div class="card__badge top left">';
      html += '          <span class="badge badge--bottom-left badge--sale prima-discount-percentage-badge color-scheme-4">';
      html += '            <span class="prima-badge-label">SALE</span>';
      html += '            <span class="prima-badge-pct">-' + discPct + '%</span>';
      html += '          </span>';
      html += '        </div>';
    }
    html += '      </div>';

    html += '      <div class="card__content">';
    html += '        <div class="card__information">';
    html += '          <h3 class="card__heading"><a href="' + productUrl + '" class="full-unstyled-link">' + safeTitle + '</a></h3>';
    html += '          <div class="card-information">';
    if (hasDiscount) {
      html += '            <div class="price price--on-sale">';
      html += '              <div class="price__container">';
      html += '                <div class="price__sale">';
      html += '                  <span><s class="price-item price-item--regular">' + comparePriceFormatted + '</s></span>';
      html += '                  <span class="price-item price-item--sale price-item--last">' + priceFormatted + '</span>';
      html += '                </div>';
      html += '              </div>';
      html += '            </div>';
    } else {
      html += '            <div class="price">';
      html += '              <div class="price__container">';
      html += '                <div class="price__regular">';
      html += '                  <span class="price-item price-item--regular">' + priceFormatted + '</span>';
      html += '                </div>';
      html += '              </div>';
      html += '            </div>';
    }
    html += '          </div>';
    html += '        </div>';
    html += '      </div>';
    html += '    </div>';
    html += '  </div>';
    html += '</li>';
    return html;
  }

  function renderPaginationControls(totalItems, activePage, onPageClick) {
    var totalPages = Math.ceil(totalItems / PRODUCTS_PER_PAGE);
    var paginationWrap = document.querySelector('.pagination-wrapper');

    if (!paginationWrap) {
      var grid = document.getElementById('product-grid');
      if (grid && grid.parentNode) {
        paginationWrap = document.createElement('div');
        paginationWrap.className = 'pagination-wrapper';
        grid.parentNode.appendChild(paginationWrap);
      }
    }

    if (!paginationWrap) return;

    if (totalPages <= 1) {
      paginationWrap.style.display = 'none';
      paginationWrap.innerHTML = '';
      return;
    }

    paginationWrap.style.display = '';
    paginationWrap.setAttribute('data-page', activePage);

    var html = '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

    // Previous button
    if (activePage > 1) {
      html += '<li><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce js-prima-page-btn" data-page="' + (activePage - 1) + '" aria-label="Trang trước">';
      html += '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      html += '</a></li>';
    }

    // Numbered pages
    for (var p = 1; p <= totalPages; p++) {
      if (p === activePage) {
        html += '<li><a href="#" class="pagination__item pagination__item--current light js-prima-page-btn" data-page="' + p + '" aria-current="page" aria-label="Trang ' + p + '">' + p + '</a></li>';
      } else {
        html += '<li><a href="#" class="pagination__item link js-prima-page-btn" data-page="' + p + '" aria-label="Trang ' + p + '">' + p + '</a></li>';
      }
    }

    // Next button
    if (activePage < totalPages) {
      html += '<li><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce js-prima-page-btn" data-page="' + (activePage + 1) + '" aria-label="Trang tiếp theo">';
      html += '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      html += '</a></li>';
    }

    html += '</ul></nav>';
    paginationWrap.innerHTML = html;

    // Attach click events
    paginationWrap.querySelectorAll('.js-prima-page-btn').forEach(function(btn) {
      btn.onclick = function(e) {
        e.preventDefault();
        var targetPage = parseInt(btn.getAttribute('data-page'), 10);
        if (targetPage && targetPage !== activePage) {
          onPageClick(targetPage);
        }
      };
    });
  }

  function displayPaginatedProducts(products, page) {
    var grid = document.getElementById('product-grid');
    var countSpan = document.getElementById('ProductCountDesktop');
    var filterCard = document.getElementById('PrimaJewelryFilterCard');
    var brandLogoUrl = filterCard ? (filterCard.getAttribute('data-brand-logo') || '') : '';

    if (!grid) return;

    currentDisplayedList = products;
    var totalPages = Math.ceil(products.length / PRODUCTS_PER_PAGE);
    if (page > totalPages && totalPages > 0) page = totalPages;
    if (page < 1) page = 1;
    currentActivePage = page;

    if (countSpan) {
      countSpan.textContent = products.length + ' products';
    }

    var start = (page - 1) * PRODUCTS_PER_PAGE;
    var slice = products.slice(start, start + PRODUCTS_PER_PAGE);

    var html = '';
    for (var i = 0; i < slice.length; i++) {
      html += buildProductCardHTML(slice[i], brandLogoUrl);
    }

    // Smooth transition
    grid.style.opacity = '0.35';
    grid.style.transition = 'opacity 0.18s ease-out';
    
    setTimeout(function() {
      grid.innerHTML = html;
      grid.style.opacity = '1';
    }, 40);

    renderPaginationControls(products.length, page, function(newPage) {
      displayPaginatedProducts(products, newPage);
      var container = document.getElementById('ProductGridContainer') || grid;
      if (container) {
        var topOffset = container.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: Math.max(0, topOffset), behavior: 'smooth' });
      }
      var url = new URL(window.location);
      url.searchParams.set('page', newPage);
      window.history.pushState({ page: newPage }, '', url.toString());
    });
  }

  function renderCategoryProductCards(category, products) {
    var grid = document.getElementById('product-grid');
    var pagination = document.querySelector('.pagination-wrapper');
    var basePath = window.location.pathname.replace(/\/$/, '');
    var isGoldCollection = basePath.endsWith('/collections/gold') || 
                           (basePath.indexOf('/collections/gold') !== -1 && basePath.indexOf('/collections/gold-') === -1);

    if (!grid) return;

    if (!category) {
      if (isGoldCollection && products) {
        var urlParams = new URLSearchParams(window.location.search);
        var initialPage = parseInt(urlParams.get('page'), 10) || 1;
        displayPaginatedProducts(products, initialPage);
        return;
      }

      if (window.__primaOriginalGridHTML) {
        grid.innerHTML = window.__primaOriginalGridHTML;
      }
      if (pagination) pagination.style.display = '';
      var countSpan = document.getElementById('ProductCountDesktop');
      if (countSpan && products) {
        countSpan.textContent = products.length + ' products';
      }
      return;
    }

    var filtered = products.filter(function(p) {
      return getCategoryByTitle(p.title) === category;
    });

    displayPaginatedProducts(filtered, 1);
  }

  function initPrimaJewelryFiltering() {
    var checkboxes = document.querySelectorAll('.js-prima-type-checkbox');
    var clearBtn = document.querySelector('.js-prima-clear-types');

    if (!checkboxes.length) return;

    var grid = document.getElementById('product-grid');
    if (grid && !window.__primaOriginalGridHTML) {
      window.__primaOriginalGridHTML = grid.innerHTML;
    }

    function onProductsReady(products) {
      updateCategoryCounts(products);

      var basePath = window.location.pathname.replace(/\/$/, '');
      var isGoldCollection = basePath.endsWith('/collections/gold') || 
                             (basePath.indexOf('/collections/gold') !== -1 && basePath.indexOf('/collections/gold-') === -1);

      if (isGoldCollection) {
        var urlParams = new URLSearchParams(window.location.search);
        var initialPage = parseInt(urlParams.get('page'), 10) || 1;

        // If on page 1 without active filter, the server Liquid already rendered
        // page 1 cleanly. We preserve existing DOM and only attach pagination controls!
        if (initialPage === 1) {
          currentDisplayedList = products;
          currentActivePage = 1;
          renderPaginationControls(products.length, 1, function(newPage) {
            displayPaginatedProducts(products, newPage);
            var container = document.getElementById('ProductGridContainer') || grid;
            if (container) {
              var topOffset = container.getBoundingClientRect().top + window.pageYOffset - 80;
              window.scrollTo({ top: Math.max(0, topOffset), behavior: 'smooth' });
            }
            var url = new URL(window.location);
            url.searchParams.set('page', newPage);
            window.history.pushState({ page: newPage }, '', url.toString());
          });
        } else {
          displayPaginatedProducts(products, initialPage);
        }
      }
    }

    // Schedule product loading cooperatively to avoid blocking initial frame rendering
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function() {
        fetchAllCollectionProducts(onProductsReady);
      }, { timeout: 1000 });
    } else {
      setTimeout(function() {
        fetchAllCollectionProducts(onProductsReady);
      }, 50);
    }

    function applyCategoryFilter() {
      var selectedCategory = '';
      checkboxes.forEach(function(cb) {
        if (cb.checked) selectedCategory = cb.value;
      });

      if (clearBtn) {
        clearBtn.style.display = selectedCategory ? 'inline-block' : 'none';
      }

      if (window.__primaCollectionProducts) {
        renderCategoryProductCards(selectedCategory, window.__primaCollectionProducts);
      } else {
        fetchAllCollectionProducts(function(products) {
          renderCategoryProductCards(selectedCategory, products);
        });
      }
    }

    checkboxes.forEach(function(cb) {
      cb.onchange = function() {
        if (this.checked) {
          checkboxes.forEach(function(otherCb) {
            if (otherCb !== cb) otherCb.checked = false;
          });
        }
        applyCategoryFilter();
      };
    });

    if (clearBtn) {
      clearBtn.onclick = function(e) {
        e.preventDefault();
        checkboxes.forEach(function(cb) { cb.checked = false; });
        applyCategoryFilter();
      };
    }
  }

  window.addEventListener('popstate', function() {
    var urlParams = new URLSearchParams(window.location.search);
    var p = parseInt(urlParams.get('page'), 10) || 1;
    if (currentDisplayedList && currentActivePage !== p) {
      displayPaginatedProducts(currentDisplayedList, p);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrimaJewelryFiltering);
  } else {
    initPrimaJewelryFiltering();
  }
  document.addEventListener('shopify:section:load', initPrimaJewelryFiltering);
})();
